import { appendIf } from '@btime/helpers'
import { colors } from '@btime/constants'
import { useTranslation } from 'react-i18next'

import { useColors } from '../../../packages/kiti/components/theme/_hooks/colors'
import {
  useUserChangePasswordAction,
  useUserDetailAction,
  useUserEditAction,
  useUserLogsAction,
  useUserRemoveAction,
  useUserTempleteRecordAction,
  useUsersEditAction,
  useUsersLogsAction,
  useUsersRemoveAction,
  useRecoverDeletedUser
} from './actions'
import { useIsOwner } from '@btime/react-session'

const useSingleActions = (item, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const colors = useColors()

  const details = useUserDetailAction(item)
  const logs = useUserLogsAction(item)
  const edit = useUserEditAction(item)
  const templateRecord = useUserTempleteRecordAction(item)
  const remove = useUserRemoveAction(item)
  const changePassword = useUserChangePasswordAction(item)
  const recoverDeletedUser = useRecoverDeletedUser(item)
  const isOwner = useIsOwner()

  if (item?.contract?.deleted) {
    return [
      ...appendIf(isOwner, {
        value: t('recoverUser'),
        icon: 'IoReloadOutline',
        onClick: recoverDeletedUser.click
      })
    ]
  }

  return [
    ...appendIf(!hide.includes('seeDetails'), {
      value: t('seeDetails'),
      icon: 'RiSearchLine',
      onClick: details.click
    }),

    ...appendIf(logs.hasPermission, {
      value: t('logs'),
      icon: 'RiTimeLine',
      onClick: logs.click,
      to: logs.link
    }),

    ...appendIf(templateRecord.hasPermission, {
      value: t('docGenerate'),
      icon: 'RiFileCloudLine',
      onClick: templateRecord.click
    }),

    ...appendIf(edit.hasPermission, {
      value: t('edit'),
      icon: 'RiPencilLine',
      onClick: edit.click
    }),

    ...appendIf(changePassword.hasPermission, {
      value: t('changePassword'),
      icon: 'RiLock2Line',
      onClick: changePassword.click
    }),

    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      icon: 'RiDeleteBin2Line',
      color: colors.red,
      onClick: remove.click
    })
  ]
}

const useMultiActions = (items, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const colors = useColors()

  // const newServiceOrder = useUserNewServiceOrderActions(items)
  const logs = useUsersLogsAction(items)
  const bulkEditModal = useUsersEditAction(items)
  const remove = useUsersRemoveAction(items)

  return [
    ...appendIf(logs.hasPermission, {
      value: t('logs'),
      icon: 'RiTimeLine',
      onClick: logs.click,
      to: logs.link
    }),

    // ...appendIf(newServiceOrder.hasPermission, {
    // value: t('createActivities'),
    // icon: 'RiInboxLine',
    // onClick: newServiceOrder.click
    // }),

    ...appendIf(bulkEditModal.hasPermission, {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: bulkEditModal.click
    }),

    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      color: colors.red,
      icon: 'BsTrash',
      onClick: remove.click
    })
  ]
}

export const useUserActionsList = (item, ids, opts = {}) => {
  const singleOptions = useSingleActions(item, opts)
  const multiOptions = useMultiActions(ids, opts)

  if (!!ids && ids.length > 1) return multiOptions
  if (!!item) return singleOptions

  return multiOptions
}
